import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LoginPage } from "./pages";
import { AdminPanel } from "./components/admin";
import {
  Contas,
  CostCenter,
  Category,
  Transaction,
  CompanyUpdate,
  Import,
  Demonstrativo,
  PaymentCalendar,
} from "./components/admin";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PublicRoute } from "./components/PublicRoute";
import { ToasterProvider } from "./components/shared";
import { CompanyProvider } from "./contexts/CompanyContext";
import { authService } from "./services";
import "./App.css";

function App() {
  return (
    <ToasterProvider>
      <CompanyProvider>
        <Router>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            >
              <Route
                path="bankAccounts"
                element={
                  <ProtectedRoute>
                    <Contas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cost-centers"
                element={
                  <ProtectedRoute>
                    <CostCenter />
                  </ProtectedRoute>
                }
              />
              <Route
                path="categories"
                element={
                  <ProtectedRoute>
                    <Category />
                  </ProtectedRoute>
                }
              />
              <Route
                path="categories/:categoryId/subcategories"
                element={<Navigate to="/categories" replace />}
              />
              <Route
                path="transactions"
                element={
                  <ProtectedRoute>
                    <Transaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management-report"
                element={
                  <ProtectedRoute>
                    <Demonstrativo />
                  </ProtectedRoute>
                }
              />
              <Route path="demonstrativo" element={<Navigate to="/management-report" replace />} />
              <Route
                path="payment-calendar"
                element={
                  <ProtectedRoute>
                    <PaymentCalendar />
                  </ProtectedRoute>
                }
              />
              <Route
                path="company"
                element={
                  <ProtectedRoute>
                    <CompanyUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="imports"
                element={
                  <ProtectedRoute>
                    <Import />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="/"
              element={<RootRedirect />}
            />
            {/* Catch-all route for non-existent routes */}
            <Route
              path="*"
              element={<NotFoundRedirect />}
            />
          </Routes>
        </Router>
      </CompanyProvider>
    </ToasterProvider>
  );
}

// Component to handle root route redirects based on authentication status
const RootRedirect: React.FC = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // If logged in, redirect to dashboard
    return <Navigate to="/transactions" replace />;
  } else {
    // If not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }
};

// Component to handle 404 redirects based on authentication status
const NotFoundRedirect: React.FC = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // If logged in, redirect to dashboard
    return <Navigate to="/transactions" replace />;
  } else {
    // If not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }
};

export default App;
